import { NOTIFICATION_MESSAGE } from "../../constants/ActionTypes";

import { message } from "antd";
message.config({
  maxCount: 2
});

const INIT_STATE = {
  message: "",
  type: "",
  notificationKey: ""
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case NOTIFICATION_MESSAGE: {
      //   const translatedMessage = translate(action.payload);
      //   message.error(translatedMessage);
      return {
        ...state,
        message: action.payload.message,
        type: action.payload.type,
        notificationKey: action.payload.notificationKey
      };
    }
    default:
      return state;
  }
};

export const notificationMessage = (msg, type) => {
  return {
    type: NOTIFICATION_MESSAGE,
    payload: {
      message: msg,
      type: type,
      notificationKey: Date.now()
    }
  };
};
